import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Index from "./containers/Index";
import Search from "./containers/Search";
import Faq from "./containers/Faq";
import PrivacyPolicy from "./containers/PrivacyPolicy";
import axios from "axios";

function App() {
  const [token, setToken] = useState(null);

  const getToken = () => {
    const payload = { userId: process.env.REACT_APP_USER_ID_TOKEN };
    console.log("App initalisée avec succès");
    console.log("Payload:", payload);
    console.log("API URL:", `${process.env.REACT_APP_API_URL}/get-token`);
    axios.post(`${process.env.REACT_APP_API_URL}/get-token`, { payload })
      .then(response => {
        setToken(response.data.token);
        localStorage.setItem('token', response.data.token);
      })
      .catch(error => {
        console.error('Error:', error.message);
      });
  };

  useEffect(() => {
    getToken();
  }, []);
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Index} />
        <Route exact path="/search" component={Search} />
        {/* <PrivateRoute exact path="/search" component={Search} /> */}
        <Route exact path="/faq" component={Faq} />
        <Route exact path="/privacy-policy" component={PrivacyPolicy} />
        {/* <PrivateRoute exact path="/faq" component={Faq} /> */}
      </Switch>
    </Router>
  );
}

export default App;





